import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveAddress, GetAddress } from "./index";

// Api's
import { addressApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getAddressSaga(action: GetAddress) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(addressApi.getDomain, action.payload.request);
		if (response.data.result) {
			yield put(saveAddress(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveAddress(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
